




















































































































































































































































import ClaimViewBaseComponent from "./ClaimViewBaseComponent";
import { Component, Watch } from "vue-property-decorator";
import ClaimSummaryViewComponent from "./claim-summary-view.vue";
import util from "@/lib/util";
import * as moment from "moment";
import { IHeader } from "@/store/models/staff/IHeader";
import {
  VcClaimDto,
  IPagedAndSortedInputDto,
  PagedAndSortedInputDto,
  IVcClaimDto,
  IClaimDataDto,
  ICurrentCustomerUserProfileDto
} from "@/asdcom/apiproxy/apiproxy.dto";
import bus from "@/components/vcponlineok/bus/bus.js";
import OnlineUserComponent from "@/components/vcponlineok/staff-user/online-user-component.vue";

interface VcClaimAssignDto {
  vcClaimId: number;
  countyName: string;
  note: string;
}

@Component({
  components: {
    ClaimSummaryViewComponent,
    OnlineUserComponent
  }
})
export default class ClaimView extends ClaimViewBaseComponent {
  loading: boolean = true;
  activeTab: number | null = null;
  claimNumber: string = "";
  columnSize: number = 12;
  isItemView: boolean = false;
  claim = new VcClaimDto();
  crimeTypes: any = [];
  howYouFindInfo: string = "";
  hasInsuranceAttach: boolean = false;
  hasAttorneyAttach: boolean = false;
  hasEmployerAttach: boolean = false;
  hasExpenceAttach: boolean = false;
  updateStatusDialogFormVisible: boolean = false;
  sendNoteDialogFormVisible: boolean = false;
  changeStatusModel: any = {
    note: "",
    status: "",
    claimId: null
  };
  btnStatusUpdate: any = null;
  btnNoteSubmit: any = null;
  sendNoteModel: any = { vcClaimId: 0, messageText: "" };
  isVisibleAppSummary: boolean = false;
  isVisibleSubmissionSummary: boolean = false;
  isVisibleClaimLog: boolean = false;
  selectedProfile: ICurrentCustomerUserProfileDto;
  isUserDetailsVisible: boolean = false;

  async created() {
    if (
      this.$route.name == "AssignClaim" ||
      this.$route.name == "ChangeStatus"
    ) {
      this.activeTab = 0;
    } else if (this.$route.name == "Messages") {
      this.activeTab = 5;
    }
    this.getCurrentClaim()
      .then((clm: IVcClaimDto) => {
        //abp.log.debug({ claimData: clm.claimData });
        // this.claim = <VcClaimDto>clm;
        this.claim = this.$store.getters["vcponlineok/getCurrentClaim"];

        abp.log.debug({ "claim-view claim": this.claim });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  @Watch("$route")
  routeChange(to: any) {
    let currentPageName = to.name;
    if (currentPageName == "AssignClaim" || currentPageName == "ChangeStatus") {
      this.activeTab = 0;
    } else if (currentPageName == "Messages") {
      this.activeTab = 5;
    }
  }

  get currentClaim() {
    if (this.$store.getters["vcponlineok/getCurrentClaim"] !== undefined) {
      return this.$store.getters["vcponlineok/getCurrentClaim"];
    } else {
      return this.claim;
    }
  }

  setActiveTab() {
    this.activeTab = 0;
  }

  getPersonFullName(obj: any) {
    if (!!obj) {
      const prefix = obj.prefix;
      const firstName = obj.firstName;
      const middleName = obj.middleName;
      const lastName = obj.lastName;
      const suffix = obj.suffix;
      const fullName = this.getFullName(
        prefix,
        firstName,
        middleName,
        lastName,
        suffix
      );
      return fullName;
    }
  }

  downloadPdf() {
    this.$appsvs.common.downloadPdfFile(this.claim.applicationPdfId as string);
  }
  downloadClaimPackagePdf() {
    this.$appsvs.common.openClaimPackagePdf(this.claim.id as number);
  }
  downloadClaimLogPdf() {
    this.$appsvs.common.openClaimLogPdf(this.claim.id as number);
  }

  openNewLogEntry() {
    if (this.$route.params.reminder !== "reminder") {
      if (this.$route.name !== "ClaimLog") {
        this.$router.push({
          name: "ClaimLog",
          params: { reminder: "reminder" }
        });
      } else if (this.$route.name == "ClaimLog") {
        this.$router.push({
          name: "ClaimLog",
          params: { reminder: "reminder" }
        });
      }
      bus.$emit("newLogEntry");
    }
  }

  openNewMessage() {
    if (this.$route.name !== " Messages" && this.$route.params.new !== "new") {
      this.$router.push({ name: "Messages", params: { new: "new" } });
    } else if (
      this.$route.name == " Messages" &&
      this.$route.params.new !== "new"
    ) {
      this.$router.push({ name: "Messages", params: { new: "new" } });
    }
    bus.$emit("newMessage");
  }

  returnToListView() {
    bus.$emit("toListView");
  }

  async retreiveOnlineUserData(id: string) {
    this.selectedProfile = await this.$appsvs.customerUser.getCustomerUserProfileByUserId(
      Number(id)
    );
    this.isUserDetailsVisible = true;
  }
}
